import React from 'react';
import './Home.css';
import { FaChartBar, FaExclamationTriangle, FaLightbulb, FaHeadset } from 'react-icons/fa';
import './Home.css';

import fertilizerImg from '../assets/fertilizer.png';
import digesterImg from '../assets/digister.png';
import tankerImg from '../assets/tanker1.png';
import ctaBgImg from '../assets/cta-bg.png';
import comprepressureImg from '../assets/Compressure.png';
import tankImg from '../assets/tank.png';
import waterscrubberImg from '../assets/waterscrubber.png';
import  cascadeImg from '../assets/cascade.png';
import h2sscrubberImg from '../assets/h2sscrubber.png';
import psapurificationImg from '../assets/psapurification.png';

const cardData = [
  {
    title: 'Circular Green Economy',
    description: 'We transform waste into high-value energy and bio-fertilizer, creating a closed-loop system that promotes sustainability and economic growth.',
    image: tankImg,
  },
  {
    title: 'Bio-Fertilizer Innovation',
    description: 'Our process yields nutrient-rich organic fertilizer, enhancing soil health and promoting sustainable agriculture.',
    image: h2sscrubberImg,
  },
  {
    title: 'Sustainable Waste Management',
    description: 'We provide an eco-friendly solution for managing agricultural and food waste, reducing landfill use and environmental pollution.',
    image: waterscrubberImg ,
  },
  {
    title: 'Carbon-Neutral Energy',
    description: 'Our compressed biogas (CBG) is a clean, renewable energy source that helps industries reduce their carbon footprint.',
    image: comprepressureImg,
  },
  {
    title: 'Anaerobic Digestion Technology',
    description: 'We utilize advanced anaerobic digestion to efficiently break down organic matter and maximize biogas production.',
    image: cascadeImg,
  },
  {
    title: 'Clean Energy for MSMEs',
    description: 'Our low-pressure mobile delivery system makes clean energy accessible and affordable for small and medium-sized enterprises.',
    image: psapurificationImg,
  },
];

const Home = () => {
  return (
     <div className="home-container">
      <h2 style={{ fontWeight: 700, marginBottom: 10 }}>Chendur Vishakan Bio Energy (P) Ltd.</h2>
      <p style={{ maxWidth: 720, margin: '0 auto' }}>
        Green Energy for a Cleaner Future — decentralized waste-to-energy, Made in India.
      </p>
      <div style={{ width: 60, height: 3, background: '#152238', margin: '16px auto 40px', borderRadius: 2 }}></div>

      <div className="features-grid">
        <div className="feature">
          <div className="feature-icon">
            <FaChartBar size={28} color="#1f2d5a" />
          </div>
          <h5 className="feature-title">Low-Pressure CBG Distribution</h5>
          <p className="text-muted feature-desc">14‑bar SMPV mobile vessels supplying 0.5–1 bar directly to MSMEs.</p>
        </div>
        <div className="feature">
          <div className="feature-icon">
            <FaExclamationTriangle size={28} color="#1f2d5a" />
          </div>
          <h5 className="feature-title">Waste-to-Energy Plants</h5>
          <p className="text-muted feature-desc">Food & agri waste biogas generation using lagoon-type digesters.</p>
        </div>
        <div className="feature">
          <div className="feature-icon">
            <FaLightbulb size={28} color="#1f2d5a" />
          </div>
          <h5 className="feature-title">CBG Purification & CO₂ Recovery</h5>
          <p className="text-muted feature-desc">Water scrubbers, H₂S removal; CO₂ recovery for dry ice production.</p>
        </div>
        <div className="feature">
          <div className="feature-icon">
            <FaHeadset size={28} color="#1f2d5a" />
          </div>
          <h5 className="feature-title">Organic By‑Products</h5>
          <p className="text-muted feature-desc">High-quality organic fertilizer and slurry utilization for agriculture.</p>
        </div>
      </div>

    <div>
      <div className="hero-section">
        {/* Your existing hero content can go here if you have any */}
      </div>

      <div className="container py-5">
        <div className="text-center mb-5">
          <h2 className="fw-bold">What We Do</h2>
          <p className="text-muted">
            We're pioneering sustainable energy solutions for a greener future.
          </p>
        </div>

        <div className="row g-4">
          {cardData.map((card, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="service-card">
                <img src={card.image} alt={card.title} className="service-card-image" />
                <div className="service-card-content">
                  <h5 className="service-card-title">{card.title}</h5>
                  <p className="service-card-text">{card.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    </div>
  );
};

export default Home;
